export const MIN_VALUE_RULE_NAME = "min_value";
/**
 * Validates that a number is not less than a minimum value.
 */
export const Validator = {
    name: MIN_VALUE_RULE_NAME,
    errorMessage: `This field must be at least :${MIN_VALUE_RULE_NAME}.`,
    validate: (value, requirement) => Number(value) >= Number(requirement),
};
